import analytics, {
  EventTypeElementImpression,
  EventTypeElementInteracted,
} from '@nerdwallet/analytics';

export const trackImpression = (entityName: string) => {
  analytics.track<EventTypeElementImpression>('element_impression', {
    element_name: entityName,
    entity_name: entityName,
  });
};

export const trackInteraction = (
  elementName: string,
  impressionId: string,
  action: EventTypeElementInteracted['Payload']['action'] = 'close'
) => {
  analytics.track<EventTypeElementInteracted>('element_interacted', {
    element_name: elementName,
    entity_name: elementName,
    action,
    interaction_id: impressionId,
    interaction_type: 'press',
  });
};
